webpackJsonp([1],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_analytics___default.a, {
  id: 'UA-10920282-25',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        company: __WEBPACK_IMPORTED_MODULE_5__config___default.a.company,
        location: window.location.href
      };
    }
  }
});

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CallMe',
  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$http.post('https://tus.la/tickets', {
        client: {
          email: this.$refs.name.value,
          phoneNumber: this.$refs.phone.value
        },
        source: '/vestel',
        text: this.$refs.text.value,
        _callCenter: '56bc4657a34c6c283780bd16'
      }).then(function () {
        _this.$router.push({ name: 'Success' });
      }).catch(console.log);
    }
  }
});

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chat',
  methods: {}
});

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Contact'
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GetStarted',
  data: function data() {
    return {
      steps: [{
        title: '4.5G Ayarını yapmak için',
        id: 1,
        isOption: true
      }, {
        title: 'Fabrika ayarlarına döndürmek için',
        id: 90,
        isOption: true
      }, {
        title: 'Ürününüzün mevcut durumu hakkında bilgi almak için',
        id: 30,
        isOption: false
      }]
    };
  }
});

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Option',
  data: function data() {
    return {
      information: false,
      steps: []
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: function $route() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      if (this.$route.params.id == 1) {
        this.steps = [{
          title: 'Venus v3 (5040, 5070, 5570)',
          id: 3,
          isOption: false
        }, {
          title: 'Venus 5.5',
          id: 10,
          isOption: false
        }];
      }

      if (this.$route.params.id == 2) {
        this.information = '<b>Talep No Nedir?:</b> Daha önce Vestel Yetkili Servislerimiz aracılığıyla Vestel ürünleriniz için hizmet almış iseniz aldığınız hizmet sonunda size bırakılan servis fişinin üzerinde ya da sistemimizde kayıtlı olan cep telefonunuza gönderilmiş olan SMS’in içerisinde 8 ile başlayan numaradır.';
        this.steps = [{
          title: 'Hizmet Talep No, Seri No veya IMEI no ile sorgulama',
          id: 30,
          isOption: false
        }];
      }

      if (this.$route.params.id == 90) {
        this.steps = [{
          title: 'Venus için',
          id: 91,
          isOption: false
        }, {
          title: 'Tablet için',
          id: 92,
          isOption: false
        }];
      }
    }
  }
});

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Question',
  data: function data() {
    return {
      contents: [],
      options: [],
      inputVal: '',
      secondInputVal: '',
      input: {
        isActive: false,
        placeholder: null,
        value: null
      },
      secondInput: {
        isActive: false,
        placeholder: null,
        value: null
      },
      onSubmit: null
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: function $route() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      if (this.$route.params.id == 3) {
        this.contents = [{
          text: 'Sim kart\u0131n\u0131z\u0131 4.5 G uyumlu sim kartla de\u011Fi\u015Ftirmeli ve operat\xF6r \xFCzerinden 4.5 G ba\u015Fvurusu yapman\u0131z\u0131 rica ediyoruz.\n                  Ba\u015Fvurunuzu yapt\u0131ysan\u0131z ad\u0131mlar\u0131 takip ederek ayarlar\u0131n\u0131z\u0131 yapabilirsiniz.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 4
        }];
      }

      if (this.$route.params.id == 4) {
        this.contents = [{
          text: 'Ana menüde orta kısımda bulunan <b>menü</b> tuşuna basarak menüye giriniz.',
          image: 'https://s3.eu-central-1.amazonaws.com/cdn.tus.la/buton.png'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 5
        }];
      }

      if (this.$route.params.id == 5) {
        this.contents = [{
          text: 'Ayarlar seçeneğine giriş yapınız.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 6
        }];
      }

      if (this.$route.params.id == 6) {
        this.contents = [{
          text: 'Açılan sayfada diğer seçeneğini tuşlayınız. '
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 7
        }];
      }

      if (this.$route.params.id == 7) {
        this.contents = [{
          text: 'Açılan sayfada Hücresel Ağlar‘a giriş yapınız.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 8
        }];
      }

      if (this.$route.params.id == 8) {
        this.contents = [{
          text: 'Açılan sayfada Tercih edilen ağ türü‘ne giriş yapınız.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 9
        }];
      }

      if (this.$route.params.id == 9) {
        this.contents = [{
          text: 'Açılan sayfada GSM/WCDMA/LTE seçeneği seçiniz. Telefonunuzu 4.5G destekli kullanmaya başlayabilirsiniz. Bu şekilde 4.5 G ayarlarınızı tamamlamış oldunuz.'
        }];

        this.options = [{
          type: 'done',
          isOption: false
        }];
      }

      if (this.$route.params.id == 10) {
        this.contents = [{
          text: 'Sim kartınızı 4.5 G uyumlu sim kartla değiştirmeli ve operatör üzerinden 4.5 G başvurusu yapmanızı rica ediyoruz. Başvurunuzu yaptıysanız adımları takip ederek ayarlarınızı yapabilirsiniz.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 11
        }];
      }

      if (this.$route.params.id == 11) {
        this.contents = [{
          text: 'Ana menüde sağ kısımda bulunan menü tuşuna basarak menüye giriniz.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 12
        }];
      }

      if (this.$route.params.id == 12) {
        this.contents = [{
          text: 'Ayarlar seçeneğine giriş yapınız.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 13
        }];
      }

      if (this.$route.params.id == 13) {
        this.contents = [{
          text: 'Açılan sayfada mobil verilere giriş yapınız.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 14
        }];
      }

      if (this.$route.params.id == 14) {
        this.contents = [{
          text: 'Açılan sayfada Tercih edilen ağ modu’na giriş yapınız.'
        }];

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 15
        }];
      }

      if (this.$route.params.id == 15) {
        this.contents = [{
          text: 'Açılan sayfada GSM/ WCDMA/ LTE seçeneğini seçiniz. Telefonunuzu  4.5G destekli kullanmaya başlayabilirsiniz. Bu şekilde 4.5 G ayarlarınızı tamamlamış oldunuz.'
        }];

        this.options = [{
          type: 'done',
          isOption: false
        }];
      }

      if (this.$route.params.id == 16) {
        this.contents = [{
          text: 'İşlem yapmak istediğiniz numarayı başında 0 olmadan 10 haneli olacak şekilde tuşlayınız.'
        }];

        this.input = {
          isActive: true,
          placeholder: '5*******'
        };
        this.secondInput = {
          isActive: false
        };
        this.onSubmit = function () {
          localStorage.setItem('customerPhoneNumber', _this.inputVal);
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://proxy-server.tusla.com.tr/windesk/app/webroot/integration/tuslaServices.php?action=checkCallStatus_first&username=tuslaWS&password=tslSrvcs&ani=' + _this.inputVal + '&dnis=tuslaIVR&uniqueid=12343&new_phone=' + _this.inputVal).then(function (res) {
            return res.data;
          }).then(function (res) {
            _this.inputVal = '';
            if (res.result.isCustomerExist === 'none') {
              localStorage.setItem('step29', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
              _this.$router.push({
                name: 'Question',
                params: {
                  id: 29
                }
              });
            } else if (res.result.isCustomerExist === 'exist') {
              localStorage.setItem('step17', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
              _this.$router.push({
                name: 'Question',
                params: {
                  id: 17
                }
              });
            }
          }).catch(function (err) {
            console.error(err);
          });
        };

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 17
        }];
      }

      if (this.$route.params.id == 30) {
        this.contents = [{
          text: 'İşlem yapmak istediğiniz Hizmet Talep No, Seri No veya IMEI no numarasını tuşlayınız. <br><br> <i>Hizmet Talep No: Vestel ürünleriniz için hizmet almış iseniz aldığınız hizmet sonunda size bırakılan servis fişinin üzerinde ya da sistemimizde kayıtlı olan cep telefonunuza gönderilmiş olan SMS’in içerisinde 8 ile başlayan numaradır.</i>'
        }];

        this.input = {
          isActive: true,
          placeholder: '80******'
        };
        this.secondInput = {
          isActive: false
        };
        this.onSubmit = function () {
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://proxy-server.tusla.com.tr/windesk/app/webroot/integration/tuslaServices.php?action=checkCallStatus_first&username=tuslaWS&password=tslSrvcs&ani=5056970162&dnis=tuslaIVR&uniqueid=12343&new_phone=5056970162&crmno=' + _this.inputVal).then(function (res) {
            return res.data;
          }).then(function (res) {
            if (res.result.open === 'none') {
              var resultObj = {
                result: {
                  reason: 'Kayıt bulunamadı.'
                }
              };
              localStorage.setItem('step18', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resultObj));
              _this.$router.push({
                name: 'Question',
                params: {
                  id: 18
                }
              });
            } else {
              localStorage.setItem('step18', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
              _this.$router.push({
                name: 'Question',
                params: {
                  id: 18
                }
              });
            }
          }).catch(function (err) {
            console.error(err);
          });
        };

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 17
        }];
      }

      if (this.$route.params.id == 29) {
        this.contents = [{
          text: 'İsim ve soyisim bilgilerinizi tuşlar mısınız?'
        }];

        this.input = {
          isActive: true,
          placeholder: 'İsim'
        };
        this.secondInput = {
          isActive: true,
          placeholder: 'Soyisim'
        };

        this.onSubmit = function () {
          var step29result = JSON.parse(localStorage.getItem('step29'));
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://proxy-server.tusla.com.tr/windesk/app/webroot/integration/tuslaServices.php?action=checkCallStatus_second&username=tuslaWS&password=tslSrvcs&ani=' + localStorage.getItem('customerPhoneNumber') + '&dnis=tuslaIVR&new_phone=' + localStorage.getItem('customerPhoneNumber') + '&callcode=' + step29result.result.callcode + '&partnerno=' + step29result.result.partnerno + '&firstname=' + _this.inputVal + '&lastname=' + _this.secondInputVal).then(function (res) {
            return res.data;
          }).then(function (res) {
            if (res.result.open === 'none') {
              var resultObj = {
                result: {
                  reason: 'Kayıt bulunamadı.'
                }
              };
              localStorage.setItem('step18', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resultObj));
              _this.$router.push({
                name: 'Question',
                params: {
                  id: 18
                }
              });
            }
          }).catch(function (err) {
            console.error(err);
          });
        };

        this.options = [{
          type: 'continue',
          isOption: false,
          id: 17
        }];
      }

      if (this.$route.params.id == 17) {
        var step17result = JSON.parse(localStorage.getItem('step17'));
        var firstname = step17result.result.firstname;
        var lastname = step17result.result.lastname;

        firstname = firstname.substring(0, firstname.length / 2).padEnd(firstname.length, '*');
        lastname = lastname.substring(0, lastname.length / 2).padEnd(lastname.length, '*');

        this.contents = [{
          text: 'Girmi\u015F oldu\u011Funuz numaraya ait ' + firstname + ' ' + lastname + ' kay\u0131tlar\u0131na ula\u015F\u0131ld\u0131. Kay\u0131t size mi ait?'
        }];

        this.input = {
          isActive: false
        };
        this.secondInput = {
          isActive: false
        };

        this.options = [{
          type: 'yes',
          isOption: false,
          isHttpRequest: true,
          onClick: function onClick() {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://proxy-server.tusla.com.tr/windesk/app/webroot/integration/tuslaServices.php?action=checkCallStatus_second&username=tuslaWS&password=tslSrvcs&ani=' + localStorage.getItem('customerPhoneNumber') + '&dnis=tuslaIVR&new_phone=' + localStorage.getItem('customerPhoneNumber') + '&callcode=' + step17result.result.callcode + '&partnerno=' + step17result.result.partnerno + '&firstname=' + step17result.result.firstname + '&lastname=' + step17result.result.lastname).then(function (res) {
              return res.data;
            }).then(function (res) {
              if (res.result.open === 'one') {
                localStorage.setItem('step18', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _this.$router.push({
                  name: 'Question',
                  params: {
                    id: 18
                  }
                });
              } else if (res.result.open === 'many') {
                localStorage.setItem('step19', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _this.$router.push({
                  name: 'Question',
                  params: {
                    id: 19
                  }
                });
              } else if (res.result.open === 'none') {
                var resultObj = {
                  result: {
                    reason: 'Kayıt bulunamadı.'
                  }
                };
                localStorage.setItem('step18', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resultObj));
                _this.$router.push({
                  name: 'Question',
                  params: {
                    id: 18
                  }
                });
              }
            }).catch(function (err) {
              console.error(err);
            });
          },
          id: 18
        }, {
          type: 'no',
          isOption: false,
          isHttpRequest: false,
          id: 29
        }];
      }

      if (this.$route.params.id == 18) {
        var step18result = JSON.parse(localStorage.getItem('step18'));
        this.contents = [{
          text: 'Sonu\xE7: ' + step18result.result.reason
        }];

        this.input = {
          isActive: false
        };
        this.secondInput = {
          isActive: false
        };

        this.options = [{
          type: 'done',
          isOption: false,
          isHttpRequest: false
        }];
      }

      if (this.$route.params.id == 91) {
        this.contents = [{
          text: 'Venus için <a href="https://youtu.be/rV13eSOwfwg" target="_blank">https://youtu.be/rV13eSOwfwg</a> linkine tıklayarak detaylı anlatım videomuzu izleyebilirsiniz.'
        }];

        this.options = [{
          type: 'done',
          isOption: false
        }];
      }

      if (this.$route.params.id == 92) {
        this.contents = [{
          text: 'Tablet için <a href="https://youtu.be/IC1uzYClOAk" target="_blank">https://youtu.be/IC1uzYClOAk</a> linkine tıklayarak detaylı anlatım videomuzu izleyebilirsiniz.'
        }];

        this.options = [{
          type: 'done',
          isOption: false
        }];
      }
    }
  }
});

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Success'
});

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/success-icon.16e6a6e.png";

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.1dab705.png";

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(118)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(230),
  /* scopeId */
  "data-v-360dafd6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(123)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  "data-v-58f4f397",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(124)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(236),
  /* scopeId */
  "data-v-bfe2109e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(120)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  "data-v-3a35dc6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(119)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(231),
  /* scopeId */
  "data-v-39717718",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(117)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  "data-v-0e0279a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(122)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  "data-v-52066a14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.contents), function(content) {
    return _c('div', [_c('img', {
      attrs: {
        "src": content.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(content.text)
      }
    }), _vm._v(" "), (_vm.input.isActive) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputVal),
        expression: "inputVal"
      }],
      attrs: {
        "type": "text",
        "name": "input",
        "placeholder": _vm.input.placeholder
      },
      domProps: {
        "value": (_vm.inputVal)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
          return _vm.onSubmit($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.inputVal = $event.target.value
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.secondInput.isActive) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.secondInputVal),
        expression: "secondInputVal"
      }],
      attrs: {
        "type": "text",
        "name": "input",
        "placeholder": _vm.secondInput.placeholder
      },
      domProps: {
        "value": (_vm.secondInputVal)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
          return _vm.onSubmit($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.secondInputVal = $event.target.value
        }
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_vm._l((_vm.options), function(option) {
    return _c('div', {
      staticClass: "button-caption"
    }, [(option.type != 'done' && option.isOption && !_vm.input.isActive && !option.isHttpRequest) ? _c('router-link', {
      class: {
        'yes': option.type == 'yes', 'no': option.type == 'no', 'continue': option.type == 'continue',
      },
      attrs: {
        "to": {
          name: 'Option',
          params: {
            id: option.id
          }
        }
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.type != 'done' && !option.isOption && !_vm.input.isActive && !option.isHttpRequest) ? _c('router-link', {
      class: {
        'yes': option.type == 'yes', 'no': option.type == 'no', 'continue': option.type == 'continue',
      },
      attrs: {
        "to": {
          name: 'Question',
          params: {
            id: option.id
          }
        }
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.input.isActive) ? _c('a', {
      class: {
        'yes': option.type == 'yes',
          'no': option.type == 'no',
          'continue': option.type == 'continue',
      },
      on: {
        "click": _vm.onSubmit
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.isHttpRequest) ? _c('a', {
      class: {
        'yes': option.type == 'yes',
          'no': option.type == 'no',
          'continue': option.type == 'continue',
      },
      on: {
        "click": option.onClick
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.type === 'done') ? _c('router-link', {
      staticClass: "continue",
      attrs: {
        "to": {
          name: 'Success'
        }
      }
    }, [_c('span', [_vm._v("BİTİR")])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('router-link', {
    staticClass: "not-these",
    attrs: {
      "to": {
        name: 'Contact',
        query: {
          gim: '1'
        }
      }
    }
  }, [_vm._v("\n      Bunların Dışında\n      "), _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CallMe"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('input', {
    ref: "name",
    attrs: {
      "type": "text",
      "placeholder": "Ad Soyad"
    }
  }), _vm._v(" "), _c('input', {
    ref: "subject",
    attrs: {
      "type": "text",
      "placeholder": "Konu"
    }
  }), _vm._v(" "), _c('input', {
    ref: "email",
    attrs: {
      "type": "text",
      "placeholder": "E-Posta"
    }
  }), _vm._v(" "), _c('input', {
    ref: "phone",
    attrs: {
      "type": "text",
      "placeholder": "Telefon Numarasi"
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "message",
    attrs: {
      "rows": "8",
      "placeholder": "Mesajınız"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n      GÖNDER\n    ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('ul', [_vm._l((_vm.steps), function(step, index) {
    return _c('li', [(!step.isOption) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Question',
          params: {
            id: step.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n        "), _c('span', {
      staticClass: "go-icon"
    }, [_c('i', {
      staticClass: "fa fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (step.isOption) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Option',
          params: {
            id: step.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n        "), _c('span', {
      staticClass: "go-icon"
    }, [_c('i', {
      staticClass: "fa fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.information) ? _c('li', {
    staticClass: "information"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.information)
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('router-link', {
    staticClass: "not-these",
    attrs: {
      "to": {
        name: 'Contact',
        query: {
          gim: '1'
        }
      }
    }
  }, [_vm._v("\n    Bunların Dışında\n    "), _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('ul', _vm._l((_vm.steps), function(step, index) {
    return _c('li', [(!step.isOption) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Question',
          params: {
            id: step.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n        "), _c('span', {
      staticClass: "go-icon"
    }, [_c('i', {
      staticClass: "fa fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (step.isOption) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Option',
          params: {
            id: step.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n        "), _c('span', {
      staticClass: "go-icon"
    }, [_c('i', {
      staticClass: "fa fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('router-link', {
    staticClass: "not-these",
    attrs: {
      "to": {
        name: 'Contact',
        query: {
          gim: '1'
        }
      }
    }
  }, [_vm._v("\n    Bunların Dışında\n    "), _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.path !== '/chat') ? _c('div', {
    staticClass: "header"
  }, [(_vm.$route.path === '/') ? _c('div', {
    staticStyle: {
      "width": "70px"
    }
  }) : _vm._e(), _vm._v(" "), (!(_vm.$route.path === '/' || _vm.$route.path === '/contact') || !(_vm.$route.query.gim == null)) ? _c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "#",
      "onclick": "window.history.back();"
    }
  }, [_vm._m(0), _vm._v("\n      Geri Dön\n    ")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(221)
    }
  }), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/chat') ? _c('div', {
    staticClass: "header chat-header"
  }, [(_vm.$route.path === '/') ? _c('div', {
    staticStyle: {
      "width": "70px"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.$route.path !== '/' && !(_vm.$route.query.gim == null))) ? _c('a', {
    staticClass: "go-back ",
    attrs: {
      "href": "#",
      "onclick": "window.history.back();"
    }
  }, [_vm._m(1), _vm._v("\n      Geri Dön\n    ")]) : _vm._e(), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(220),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("İşleminiz Başarılı!")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'GetStarted',
      }
    }
  }, [_c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n    BAŞA DÖN\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat"
  }, [_c('iframe', {
    attrs: {
      "src": "https://livechat.connexease.com/embed/5d432f58-c1e6-4b09-b5ce-481421020719"
    }
  })])
}]}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('ul', [_c('li', {
    staticClass: "wp-web"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://api.whatsapp.com/send?phone=908502224123"
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Whatsapp")]), _vm._v(" "), _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
}]}

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(217)

module.exports = {
  company: 'Vestel',
  build: {
    env: __webpack_require__(45),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(86),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GetStarted__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GetStarted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_GetStarted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Question__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Option__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Contact__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CallMe__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CallMe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_CallMe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Success__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Chat__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Chat__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'GetStarted',
    component: __WEBPACK_IMPORTED_MODULE_2__components_GetStarted___default.a
  }, {
    path: '/chat',
    name: 'Chat',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Chat___default.a
  }, {
    path: '/question/:id',
    name: 'Question',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Question___default.a,
    props: true
  }, {
    path: '/option/:id',
    name: 'Option',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Option___default.a
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Contact___default.a
  }, {
    path: '/callme',
    name: 'CallMe',
    component: __WEBPACK_IMPORTED_MODULE_6__components_CallMe___default.a
  }, {
    path: '/success',
    name: 'Success',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Success___default.a
  }]
}));

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(121)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(239)
var prodEnv = __webpack_require__(45)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ })

},[105]);


// WEBPACK FOOTER //
// static/js/app.cac42548482b8e7b9af5.js